import { render, staticRenderFns } from "./ExcelDownloadIcon.vue?vue&type=template&id=4ff11722&"
import script from "./ExcelDownloadIcon.vue?vue&type=script&lang=tsx&"
export * from "./ExcelDownloadIcon.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports